import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { 
		clsx
	} from 'clsx'

	import {
		MenuItems,
		TransitionRoot
	} from '@headlessui/vue'

	import {
		inject,
		computed
	} from "vue"

	
	const __default__ = { name: 'VDropdownMenu' }// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		anchor: {
			type: String,
			default: "bottom"
		},
		className: {
			type: String,
			default: ""
		}
	},
  setup(__props) {

const props = __props;

	

	const menuId: string = inject('menuId', null) || ""

	// const boundingRect = computed(() => {
	// 	const button = document.getElementById(menuId)
	// 	return button?.getBoundingClientRect()
	// })

	// const boundingRectMenu = computed(() => {
	// 	const menu = document.getElementById('items-' + menuId)
	// 	return menu?.getBoundingClientRect()
	// })

	// const menuPlacement = computed(() => {
	// 	switch(props.anchor) {
	// 		case 'bottom':
	// 			return `top: ${(boundingRect.value?.bottom ?? 0) + 8}px;`
	// 		case 'top':
	// 			return `top: ${(boundingRect.value?.top ?? 0) - 8 - (boundingRectMenu.value?.height ?? 0)}px;`
	// 		default:
	// 			return `top: ${(boundingRect.value?.bottom ?? 0) + 8}px;`
	// 	}
	// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    leave: "duration-100 ease-in",
    "leave-to": "opacity-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(MenuItems), {
        id: 'items-' + _unref(menuId),
        anchor: __props.anchor,
        class: _normalizeClass(_unref(clsx)(
				__props.className,
				'absolute z-10 mt-2 right-0',
				// Anchor positioning
				'[--anchor-gap:theme(spacing.2)] [--anchor-padding:theme(spacing.1)] data-[anchor~=end]:[--anchor-offset:6px] data-[anchor~=start]:[--anchor-offset:-6px] sm:data-[anchor~=end]:[--anchor-offset:4px] sm:data-[anchor~=start]:[--anchor-offset:-4px]',
				// Base styles
				'isolate w-max rounded-xl p-1',
				// Invisible border that is only visible in `forced-colors` mode for accessibility purposes
				'outline outline-1 outline-transparent focus:outline-none',
				// Handle scrolling when menu won't fit in viewport
				'overflow-y-auto',
				// Popover background
				'bg-white/75 backdrop-blur-xl dark:bg-zinc-800/75',
				// Shadows
				'shadow-lg ring-1 ring-zinc-950/10 dark:ring-inset dark:ring-white/10',
				// Define grid at the menu level if subgrid is supported
				'supports-[grid-template-columns:subgrid]:grid supports-[grid-template-columns:subgrid]:grid-cols-[auto_1fr_1.5rem_0.5rem_auto]'
			))
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["id", "anchor", "class"])
    ]),
    _: 3
  }))
}
}

})